// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
    there are placeholder classes in this file 
    since for some reason some first 
    apperances of selectors get ignored
    for instance:
    .file-explorer thead:hover {}
*/

.file-explorer {
    overflow: auto;
    max-height: 100%;
    min-height: 100%;
}

.file-explorer table {
    table-layout: fixed;

    width: 100%;

    height: 100%;
    max-height: 100%;

    border-collapse: collapse;

    overflow: auto;
};

.file-explorer thead:hover {}

.file-explorer thead {
    border-top: 1px solid #c0c0c0;
    border-bottom: 1px solid #c0c0c0;
}

.file-explorer thead th {
    padding: 0.7rem 0 0.7rem 0;
}

.file-explorer thead th:first-child {
    width: 75%;
}

.file-explorer thead th:nth-child(2) {
    width: 12.5%;
}

.file-explorer thead th:nth-child(3) {
    width: 12.5%;
}

.file-explorer__file-row {
    height: 4rem;
    cursor: pointer;
    border-bottom: 1px solid #f1f1f1;
}


@media screen and (hover: hover) {
    .file-explorer__file-row:hover {
        background-color: #f1f1f1;
    }
}


@media screen and (not (hover: hover)) {
    .file-explorer__file-row:active {
        background-color: #f1f1f1;
    }    
}`, "",{"version":3,"sources":["webpack://./src/components/fileExplorer/fileExplorer.css"],"names":[],"mappings":"AAAA;;;;;;CAMC;;AAED;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;;IAEnB,WAAW;;IAEX,YAAY;IACZ,gBAAgB;;IAEhB,yBAAyB;;IAEzB,cAAc;AACjB,CAAA;;AAED,4BAA4B;;AAE5B;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gCAAgC;AACpC;;;AAGA;IACI;QACI,yBAAyB;IAC7B;AACJ;;;AAGA;IACI;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["/* \n    there are placeholder classes in this file \n    since for some reason some first \n    apperances of selectors get ignored\n    for instance:\n    .file-explorer thead:hover {}\n*/\n\n.file-explorer {\n    overflow: auto;\n    max-height: 100%;\n    min-height: 100%;\n}\n\n.file-explorer table {\n    table-layout: fixed;\n\n    width: 100%;\n\n    height: 100%;\n    max-height: 100%;\n\n    border-collapse: collapse;\n\n    overflow: auto;\n};\n\n.file-explorer thead:hover {}\n\n.file-explorer thead {\n    border-top: 1px solid #c0c0c0;\n    border-bottom: 1px solid #c0c0c0;\n}\n\n.file-explorer thead th {\n    padding: 0.7rem 0 0.7rem 0;\n}\n\n.file-explorer thead th:first-child {\n    width: 75%;\n}\n\n.file-explorer thead th:nth-child(2) {\n    width: 12.5%;\n}\n\n.file-explorer thead th:nth-child(3) {\n    width: 12.5%;\n}\n\n.file-explorer__file-row {\n    height: 4rem;\n    cursor: pointer;\n    border-bottom: 1px solid #f1f1f1;\n}\n\n\n@media screen and (hover: hover) {\n    .file-explorer__file-row:hover {\n        background-color: #f1f1f1;\n    }\n}\n\n\n@media screen and (not (hover: hover)) {\n    .file-explorer__file-row:active {\n        background-color: #f1f1f1;\n    }    \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
